import { useMainStore } from '~/store/main';
import Authentication from '~/../frontend-shared/js/authentication';

const authenticationPaths = {
	loginPath: '/log-ind/',
	logoutPath: '/log-ud/',
	paymentPath: '/abonnement/',
	restrictedRoutes: [
		{
			path: '/vidensbase/*/',
			access: 'subscription'
		},		
		{
			path: '/virksomhed/',
			access: 'subscription'
		},		
		{
			path: '/virksomhed/*/',
			access: 'subscription'
		},
		{
			path: '/abonnement/',
			access: 'login'
		},
		{
			path: '/behandlingsguide/',
			access: 'login'
		}		
	]
}

//define middleware
export default defineNuxtRouteMiddleware(async (to) => {
	const mainStore = useMainStore();
	const authShared = new Authentication(authenticationPaths, 'mba');
	
	const redirectRoute = await authShared.middlewareHandler(to, mainStore);
	if (redirectRoute != null)
	{

		return navigateTo(redirectRoute, {
			external: true
		});
	}
});